export const don_statistic_cols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
        width: 10,
        align: 'center',
        renderFormItem: () => false
    },
    {
        title: '开立日',
        en_title: 'Issuance date',
        ch_title: '开立日',
        dataIndex: '开立日',
        width: 20,
        align: 'center',
        hideInTable: true, // 开立日筛选条件需要，但表格中不显示
        renderFormItem: () => false
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
        width: 30,
        align: 'center',
        renderFormItem: () => false
    },
    {
        title: '捐款项目',
        en_title: 'Donation items',
        ch_title: '捐款项目',
        dataIndex: '捐款项目',
        width: 20,
        align: 'center',
        renderFormItem: () => false
    },
    {
        title: '笔数',
        en_title: 'Number of transactions',
        ch_title: '笔数',
        dataIndex: '笔数',
        align: 'center',
        width: 20,
        renderFormItem: () => false,
    },
    {
        title: '金额',
        ch_title: '金额',
        en_title: 'Amount',
        dataIndex: '金额',
        align: 'center',
        width: 20,
        renderFormItem: () => false,
    },
    // {
    //     title: '捐款统计',
    //     dataIndex: '捐款统计',
    //     align: 'center',
    //     renderFormItem: () => false,
    //     children: [
    //         {
    //             title: '笔数',
    //             dataIndex: '笔数',
    //             align: 'center',
    //             width: 20,
    //         },
    //         {
    //             title: '金额',
    //             dataIndex: '金额',
    //             align: 'center',
    //             width: 20,
    //         },
    //     ]
    // },
];